//#region src/api/internal/response-stream.ts
var ResponseStream = class {
	#writer;
	#encoder;
	#abortSubscribers = [];
	#responseReadable;
	#aborted = false;
	#closed = false;
	/**
	* Whether the stream has been aborted.
	*/
	get aborted() {
		return this.#aborted;
	}
	/**
	* Whether the stream has been closed normally.
	*/
	get closed() {
		return this.#closed;
	}
	/**
	* The readable stream that the response is piped to.
	*/
	get responseReadable() {
		return this.#responseReadable;
	}
	constructor(writable, readable) {
		this.#writer = writable.getWriter();
		this.#encoder = new TextEncoder();
		const reader = readable.getReader();
		this.#abortSubscribers.push(async () => {
			await reader.cancel();
		});
		this.#responseReadable = new ReadableStream({
			async pull(controller) {
				const { done, value } = await reader.read();
				if (done) controller.close();
				else controller.enqueue(value);
			},
			cancel: () => {
				this.abort();
			}
		});
	}
	async writeRaw(input) {
		try {
			if (typeof input === "string") input = this.#encoder.encode(input);
			await this.#writer.write(input);
		} catch {}
	}
	write(input) {
		return this.writeRaw(JSON.stringify(input) + "\n");
	}
	sleep(ms) {
		return new Promise((res) => setTimeout(res, ms));
	}
	async close() {
		try {
			await this.#writer.close();
		} catch {} finally {
			this.#closed = true;
		}
	}
	onAbort(listener) {
		this.#abortSubscribers.push(listener);
	}
	/**
	* Abort the stream.
	* You can call this method when stream is aborted by external event.
	*/
	abort() {
		if (!this.aborted) {
			this.#aborted = true;
			this.#abortSubscribers.forEach((subscriber) => subscriber());
		}
	}
};

//#endregion
export { ResponseStream };
//# sourceMappingURL=response-stream.js.map